import { createStyles } from "antd-style";

export const useModalLicenseAgreementStyles = createStyles(({ css }: any) => ({
  modalContent: css`
    border-radius: 0;
  `,
  modalMask: css`
    background-color: transparent !important;
  `,
  modal: css`
    top: 0 !important;
    width: 100% !important;
    max-width: 100% !important;
    padding: 0 !important;
  `,
  content: css`
    text-align: justify;
    p {
      text-indent: 0 !important;
    }
    ul {
      list-style-type: none;
      padding: 0;

      li {
        padding-bottom: 4px;
      }
    }
  `,
  actions: css``,
}));
